import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XIcon } from 'lucide-react';
type LegalModalProps = {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
};
export function LegalModal({
  isOpen,
  onClose,
  title,
  children
}: LegalModalProps) {
  return <AnimatePresence data-id="element-159">
      {isOpen && <>
          <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.3
      }} className="fixed inset-0 bg-charcoal/60 backdrop-blur-sm z-50" onClick={onClose} data-id="element-160" />
          <motion.div initial={{
        opacity: 0,
        y: 40,
        scale: 0.97
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 40,
        scale: 0.97
      }} transition={{
        duration: 0.4,
        ease: [0.22, 1, 0.36, 1]
      }} className="fixed inset-4 md:inset-x-auto md:inset-y-8 md:max-w-2xl md:mx-auto bg-cream rounded-sm shadow-2xl z-50 flex flex-col overflow-hidden" data-id="element-161">
            <div className="flex items-center justify-between px-6 md:px-10 py-5 border-b border-sand" data-id="element-162">
              <h2 className="text-2xl font-serif text-charcoal" data-id="element-163">{title}</h2>
              <button onClick={onClose} className="p-2 rounded-full hover:bg-sand/60 transition-colors" aria-label="Cerrar" data-id="element-164">
                <XIcon className="w-5 h-5 text-charcoal/70" data-id="element-165" />
              </button>
            </div>
            <div className="flex-1 overflow-y-auto px-6 md:px-10 py-8 text-charcoal/80 leading-relaxed space-y-6 text-base" data-id="element-166">
              {children}
            </div>
          </motion.div>
        </>}
    </AnimatePresence>;
}
export function PrivacyContent() {
  return <>
      <p className="text-sm uppercase tracking-widest text-charcoal/50 mb-2" data-id="element-167">
        Última actualización: abril 2026
      </p>

      <h3 className="text-xl font-serif text-charcoal" data-id="element-168">
        1. Información que recopilamos
      </h3>
      <p data-id="element-169">
        Recopilamos únicamente la información necesaria para procesar tu compra
        y entregarte el producto digital. Esto puede incluir tu nombre,
        dirección de correo electrónico y datos de pago procesados de forma
        segura a través de terceros.
      </p>

      <h3 className="text-xl font-serif text-charcoal" data-id="element-170">
        2. Uso de la información
      </h3>
      <p data-id="element-171">Tu información se utiliza exclusivamente para:</p>
      <ul className="list-disc pl-6 space-y-2" data-id="element-172">
        <li data-id="element-173">Procesar y entregar tu compra</li>
        <li data-id="element-174">Enviarte actualizaciones relacionadas con el producto</li>
        <li data-id="element-175">Mejorar nuestro servicio</li>
      </ul>

      <h3 className="text-xl font-serif text-charcoal" data-id="element-176">
        3. Protección de datos
      </h3>
      <p data-id="element-177">
        No vendemos, compartimos ni transferimos tu información personal a
        terceros. Utilizamos medidas de seguridad estándar de la industria para
        proteger tus datos.
      </p>

      <h3 className="text-xl font-serif text-charcoal" data-id="element-178">4. Cookies</h3>
      <p data-id="element-179">
        Este sitio puede utilizar cookies esenciales para su funcionamiento. No
        utilizamos cookies de seguimiento publicitario.
      </p>

      <h3 className="text-xl font-serif text-charcoal" data-id="element-180">5. Tus derechos</h3>
      <p data-id="element-181">
        Puedes solicitar la eliminación de tus datos en cualquier momento.
        Responderemos a tu solicitud en un plazo máximo de 30 días.
      </p>
    </>;
}
export function TermsContent() {
  return <>
      <p className="text-sm uppercase tracking-widest text-charcoal/50 mb-2" data-id="element-182">
        Última actualización: abril 2026
      </p>

      <h3 className="text-xl font-serif text-charcoal" data-id="element-183">1. Producto digital</h3>
      <p data-id="element-184">
        "Tu cuerpo no se equivocó" es un producto digital de carácter
        informativo y educativo. No sustituye el consejo médico profesional,
        diagnóstico ni tratamiento.
      </p>

      <h3 className="text-xl font-serif text-charcoal" data-id="element-185">2. Uso personal</h3>
      <p data-id="element-186">
        El contenido adquirido es para uso personal y no puede ser reproducido,
        distribuido ni compartido sin autorización expresa.
      </p>

      <h3 className="text-xl font-serif text-charcoal" data-id="element-187">
        3. Política de reembolso
      </h3>
      <p data-id="element-188">
        Debido a la naturaleza digital del producto, todas las ventas son
        finales. Si experimentas algún problema técnico con la descarga, nos
        comprometemos a resolverlo.
      </p>

      <h3 className="text-xl font-serif text-charcoal" data-id="element-189">
        4. Descargo de responsabilidad
      </h3>
      <p data-id="element-190">
        La información contenida en esta guía se basa en investigación y
        experiencia general. Los resultados pueden variar de persona a persona.
        Siempre consulta con un profesional de la salud antes de realizar
        cambios significativos en tu estilo de vida.
      </p>

      <h3 className="text-xl font-serif text-charcoal" data-id="element-191">5. Modificaciones</h3>
      <p data-id="element-192">
        Nos reservamos el derecho de actualizar estos términos en cualquier
        momento. Los cambios serán efectivos a partir de su publicación en esta
        página.
      </p>
    </>;
}